import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  CardMedia,
  Chip,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import useTranslationService, {
  translationService,
} from "e.sic-platform.webclient/src/services/translation/TranslationService";
import { observer } from "mobx-react-lite";
import { Coin } from "../../../components/shop/Coin";
import {
  activityPricesStorage,
  ActivityTypes,
} from "e.sic-platform.webclient/src/services/shop/ActivityPricesStorage";
import { useCallback, useMemo } from "react";
import Tooltip from "@mui/material/Tooltip";
import { useNavigate } from "react-router-dom";
import { Flags } from "e.sic-platform.webclient/src/generated/FeatureFlags";
import { featureFlagsStorage } from "e.sic-platform.webclient/src/services/feature-flags/FeatureFlagsStorage";

export interface SmartAppPreviewProps {
  title: string;
  image: string | React.ReactNode;
  description: string;
  route: string;
  hasPadding?: Boolean;
  name?: ActivityTypes[];
  enabled?: Flags;
}

export default observer(function SmartAppPreview(props: SmartAppPreviewProps) {
  const { title, image, description, route, name, enabled } = { ...props };
  const { translate } = useTranslationService();
  const navigate = useNavigate();
  const totalApps = useMemo(() => 5 - featureFlagsStorage.disabledApps(), [featureFlagsStorage.disabledApps])
  const xl = useMemo(() => {
    if (route.startsWith("https")) return 6;
    return 3;
  }, [totalApps]);

  const costs = useMemo(
    () => name === undefined ? 0 : activityPricesStorage.getPrices(props.name!),
    [activityPricesStorage, props.name]
  );

  const goToApp = useCallback(() => {
    if (route.startsWith("https")) {
      const newWindow = window.open(route, "_blank", "noopener,noreferrer");
      if (newWindow) newWindow.opener = null;
    } else {
      navigate(route) 
    }
  }, [route]);

  if (enabled !== undefined) {
    if (!featureFlagsStorage.isFeatureEnabled(enabled))
      return (<></>)
  }

  return (
    <Grid item xs={12} xl={xl} lg={6}>
      <div onClick={goToApp}>
        <Card elevation={10} style={{ cursor: "pointer" }}>
          <CardHeader
            title={translate(title)}
            titleTypographyProps={{ fontSize: "1.3rem", fontWeight: "bold" }}
            subheader={
              <Typography variant="caption">
                {translate("general.bySarida")}
              </Typography>
            }
          />

          {typeof image === "string" ? (
            <CardMedia image={image} component="img" />
          ) : (
            image
          )}

          <CardContent>
            <Tooltip title={translate(description)}>
              <Typography
                variant="body2"
                style={{
                  flexGrow: 1,
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: "1",
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                }}
              >
                {translate(description)}
              </Typography>
            </Tooltip>
          </CardContent>
          {props.name && (
            <CardActions>
              <Stack marginLeft="auto" direction="row">
                <Coin
                  text={translationService.translate("general.appCosts")}
                  amount={costs}
                />
              </Stack>
            </CardActions>
          )}
        </Card>
      </div>
    </Grid>
  );
});
